<div class="card">
    <h5>Please Wait!</h5>
    <br>
<div class="con">
       
    <div class="wrapper">
        <span  style="--i:1">
            <span class="bubble">

            </span>
        </span>
        <span  style="--i:2">
            <span class="bubble">

            </span>
        </span>
        <span  style="--i:3">
            <span class="bubble">

            </span>
        </span>
        <span  style="--i:4">
            <span class="bubble">

            </span>
        </span>
        <span  style="--i:5">
            <span class="bubble">

            </span>
        </span>
        <span  style="--i:6">
            <span class="bubble">

            </span>
        </span>
        <span style="--i:7">
            <span class="bubble">

            </span>
        </span>
        <span  style="--i:8">
            <span class="bubble">

            </span>
        </span>
        <span  style="--i:9">
            <span class="bubble">

            </span>
        </span>
        <span style="--i:10">
            <span class="bubble">

            </span>
        </span>
        <span style="--i:10">
            <span class="bubble">

            </span>
        </span>
        <span style="--i:12">
            <span class="bubble">

            </span>
        </span>


    </div>

</div>
<br><br>

<!-- <p class="message">Processing...</p>
<button type="button" class="btn btn-sm" data-dismiss="modal">Cancel</button>
<br><br> -->

</div>
